
import Vue from 'vue';

/** Renders pagination controls, inputs are 0-based, meaning page === 0 will render as 1 on the label */
export default Vue.extend({
	props: {
		page: Number,
		pageActive: {
			type: Boolean,
			default: true
		},
		maxPage: {
			type: Number,
			default: Number.MAX_VALUE,
		},
		minPage: {
			type: Number,
			default: 0,
		},
		disabled: Boolean,
		editable: {
			type: Boolean,
			default: true
		},
		showOffsets: {
			type: Boolean,
			default: true
		}
	},
	data: () => ({
		focus: false,
	}),
	computed: {
		lowerPages(): number[] {
			return this.calcOffsets(this.boundedPage - this.minPage).reverse().map(o => this.boundedPage - o);
		},
		higherPages(): number[] {
			return this.calcOffsets(this.maxPage - this.boundedPage).map(o => this.boundedPage + o);
		},
		nextEnabled(): boolean {
			return this.boundedPage < this.maxPage;
		},
		prevEnabled(): boolean {
			return this.boundedPage > this.minPage;
		},

		boundedPage(): number { return Math.max(this.minPage, Math.min(this.page, this.maxPage)); }
	},
	methods: {
		calcOffsets(range: number) {
			if (range <= 0) return [];
			if (range <= 1) return [1];
			if (range <= 2) return [1,2];
			if (range <= 5) return [1,2,range];
			if (range <= 10) return [1,2,5,range];
			return [1,2,3,5,10];
		},
		isValid(page: any): page is number {
			return typeof page === 'number' &&
				!isNaN(page) &&
				(page !== this.page || !this.pageActive) && // emit event for current page if the page is not active (i.e. is page is just center of the pagination, but not the "current" page)
				page >= this.minPage &&
				page <= this.maxPage
		},
		changePage(page: any) {
			if (!this.disabled && this.isValid(page)) {
				this.$emit('change', page)
			}
		}
	},
	beforeUpdate() {
		this.focus = document.activeElement === this.$refs.maincontrol;
	},
	updated() {
		if (this.focus) {
			(this.$refs.maincontrol as HTMLInputElement).focus();
		}
	},

})
